import type { App } from 'vue'
import { filter } from './index'

export default {
  install: (app: App) => {
    app.config.globalProperties.$f = filter
  },
}
